import { LitElement, html } from "lit-element";
import { ifDefined } from 'lit-html/directives/if-defined.js';
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import { navigate } from "../actions/app.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { CardStyles } from "../styles/card-styles.js";
import { InspectionListStyles } from "../styles/inspection-list-styles.js";
import "../elements/inspx-db-image.js";
import "@material/mwc-button";
import "@material/mwc-slider";
import { contentCopy, deleteForever, sync } from "../styles/icons.js";
import { copyLocalInspection } from "../actions/local-inspections.js";
import { deleteCopiedInspectionAct } from "../actions/local-inspections.js";
import { InspxDialog } from "../elements/inspx-dialog.js";
import { createOverlay } from "../lib/helpers.js";
import { getInspectionFirstTab } from "../inspection-loader-middleware.js";
import { keyboardArrowDown, keyboardArrowUp } from '../styles/icons.js';

class InspxLocalInspections extends connect(store)(LitElement) {
	render() {
		return html`
            ${SharedStyles}
            ${CardStyles}
            ${InspectionListStyles}
            
            <div class="list">
                ${this.items.map(c => this._renderCustomer(c))}
            </div>`;
	}

	_renderCustomer(c) {
		return html`
            <div class="topGroup">${c.customerName}</div>
            ${c.projects.map((p, idx) => this._renderProject(p, idx))}`;
	}

	_renderProject(p, idx) {
		let collapsed = this.opennedProjects.indexOf(idx + '_' + p.projectName) === -1;
		let hasPrev = p.inspections.find(i => this.prevInspId == i._key);
		if (hasPrev && !this.__onceRendered) {
			this.__onceRendered = true;
			collapsed = false;
			this.opennedProjects.push(idx + '_' + p.projectName);
		}
		const projectClick = () => {
			let index = this.opennedProjects.indexOf(idx + '_' + p.projectName);
			if (index > -1) this.opennedProjects.splice(index, 1);
			else this.opennedProjects.push(idx + '_' + p.projectName);
			this.requestUpdate();
		};
		return html`
			<div class="nestedGroup" @click="${projectClick}">
				${p.projectName}
				<div class="button">${collapsed ? keyboardArrowDown : keyboardArrowUp}</div>
			</div>
            ${p.inspections.map(i => this._renderInspection(i, collapsed))}`;
	}

	_renderInspection(i, collapsed) {
		let copyIcon = this.swCopying ? sync : contentCopy;
		let deleteIcon = this.swCopying ? sync : deleteForever;

		let copyButton = i._key.startsWith('copy_')
			? ""
			: html`<mwc-button title="copy" @click="${(e) => this.copyInsp(e, i)}">${copyIcon}</mwc-button>`;
		let deleteButton = i.copiedFrom == undefined
			? ""
			: html`<mwc-button title="delete" @click="${(e) => this.deleteInsp(e, i)}">${deleteIcon}</mwc-button>`;

		let prevSelector = undefined;
		if (this.prevInspId == i._key) {
			prevSelector = "prevSelector";
			if (!this.__onceScrolled) {
				this.__onceScrolled = true;
				this.updateComplete.then(() => {
					let e = this.shadowRoot.getElementById(prevSelector);
					if (e && typeof e.scrollIntoView === 'function') e.scrollIntoView({ behavior: "smooth", block: "center" });
				
				});
			}
		}
		return html`
            <div class="card" @click="${() => this.goToInspection(i)}" id="${ifDefined(prevSelector)}" ?collapsed="${collapsed}">
                <div class="h-image">
                    <inspx-db-image hideInfo isCover .src="${i.cover_image_id || ''}"></inspx-db-image>
                </div>
                <div class="h-actions">
                    ${copyButton}
                    ${deleteButton}
                </div>
                <div class="f">
                          <div>
                    <span>
                        ${i.name}                   
                    </span>
                     </br>
                      <span>
                           ${(i.Algemeen && i.Algemeen.Algemeen && i.Algemeen.Algemeen.Monsternummer_opdrachtgever) ? "Nr: " + i.Algemeen.Algemeen.Monsternummer_opdrachtgever : ""}
                        </span>
                          <span>
                            ${(i.Algemeen && i.Algemeen.Algemeen && i.Algemeen.Algemeen.Monstername_punt) ? "Punt: " + i.Algemeen.Algemeen.Monstername_punt : ""}
                        </span>                       
                    </div>
                    <div class="info">
                        <span>
                            ${i.type.name}
                        </span>
                        <span>
                            ${i.date}
                        </span>
                    </div>
                </div>
            </div>`;
	}

	async deleteInsp(e, i) {
		e.preventDefault();
		e.stopPropagation();

		const dialogId = "deleteInspDialog";
		if (this.swCopying || document.getElementById(dialogId)) return;

		let dialog = new InspxDialog();
		dialog.id = dialogId;
		dialog.cancellable = true;
		dialog.headerLabel = 'Delete confirmatie';
		dialog.content = 'Weet je zeker dat je deze inspectie wilt verwijderen?';
		dialog.acceptLabel = 'Ja';
		dialog.cancelLabel = 'Nee';
		dialog.addEventListener('dialog-accept', async () => {
			dialog.remove();
			let overlay = createOverlay();
			await store.dispatch(deleteCopiedInspectionAct(i));
			await this.requestUpdate();
			overlay.remove()
		});
		dialog.addEventListener('dialog-cancel', () => dialog.remove());
		document.body.appendChild(dialog);
		dialog.open();
	}

	goToInspection(i) {
		if (this.swCopying) return;
		let firstTab = getInspectionFirstTab(i.type.schema) || '';
		store.dispatch(navigate(`/inspection/${i._key}/${firstTab}`));
	}

	async copyInsp(e, i) {
		e.preventDefault();
		e.stopPropagation();

		const dialogId = "copyInspDialog";
		if (this.swCopying || document.getElementById(dialogId)) return;

		let copying = false;
		let copyNumber = 1;
		let dialog = new InspxDialog();
		dialog.id = dialogId;
		dialog.cancellable = true;
		dialog.headerLabel = 'Kopieer confirmatie';
		dialog.content = 'Weet je zeker dat je de inspectie wilt kopieren?';
		dialog.acceptLabel = 'Ja';
		dialog.cancelLabel = 'Nee';
		dialog.addEventListener('dialog-accept', async () => {
			dialog.remove();
			if (copying) return;
			copying = true;
			copyNumber = isNaN(copyNumber) || copyNumber < 1 ? 1 : (copyNumber > 10 ? 10 : copyNumber);
			window.sync.postMessage({ name: "copyInspectionStarted" });

			let overlay = createOverlay();
			try {
				for (let count = 0; count < copyNumber; count++) {
					let copyCompletionResolve
					const copyCompletion = new Promise((resolve) => copyCompletionResolve = resolve);
					store.dispatch(copyLocalInspection(i))
						.finally(() => copyCompletionResolve());
					await copyCompletion;
					const waitabit = new Promise((resolve) => setTimeout(() => resolve(1), 300));
					await waitabit;
				}
			} catch (error) {
				console.log(error);
			} finally {
				window.sync.postMessage({ name: "copyInspectionFinished" });
				overlay.remove();
				copying = false;
			}			
		});
		dialog.addEventListener('dialog-cancel', () => dialog.remove());
		document.body.appendChild(dialog);
		dialog.open();

		await dialog.updateComplete;
		if (dialog.shadowRoot) {
			const slot = dialog.shadowRoot.querySelector("slot");
			if (slot) {
				const summary = document.createElement("summary");
				summary.innerText = "Uitklappen voor meer kopieën";
				summary.addEventListener("click", () => details.open = !details.open);
				
				const slider = document.createElement("mwc-slider");
				slider.discrete = true;
				slider.withTickMarks = true;
				slider.step = 1;
				slider.min = 1;
				slider.max = 10;
				slider.value = 1;
				slider.addEventListener("change", (event) => copyNumber = Number(event.target.value));
				slider.style.marginTop = "30px";
				slider.style.setProperty("--mdc-theme-primary", "white");
				
				const p = document.createElement("p");
				p.appendChild(slider);
				
				const details = document.createElement("details");
				details.appendChild(summary);
				details.appendChild(p);
				
				slot.appendChild(details);
			}
		}
	}

	static get properties() {
		return {
			items: Array,
			prevInspId: Number,
			swCopying: Boolean,
		};
	}

	constructor() {
		super();
		this.items = [];
		this.prevInspId = 0;
		this.swCopying = false;
		this.opennedProjects = [];
		this.__syncMessageHandler = (e) => {
			if (e.data.name === 'copyInspectionSwStarted') {
				this.swCopying = true;
			} else if (e.data.name === 'copyInspectionSwFinished') {
				this.swCopying = false;
			}
		};
	}

	connectedCallback() {
		super.connectedCallback();
		window.sync.addEventListener("message", this.__syncMessageHandler);
	}

	disconnectedCallback() {
		super.disconnectedCallback();
		window.sync.removeEventListener("message", this.__syncMessageHandler);
	}

	stateChanged(state) { 
		this.items = this.getGroupedInspections(state.localInspections.items);
		this.prevInspId = state.inspection.prevInspId;
	}

	getGroupedInspections(items) {
		const defaultLabel = "others";
		const byCustomer = this.groupBy(items, i => i.customerId);
		const byCustomerAndProject = Object.entries(byCustomer).map(f => {
			const cust = f[1].find(i => i.customerName);
			const customerName = cust ? cust.customerName : "";
			const byProject = this.groupBy(f[1], d => d.projectName || defaultLabel);
			return {
				customerId: f[0],
				customerName: customerName || defaultLabel,
				projects: Object.entries(byProject)
					.map(f2 => {
						return {
							projectName: f2[0],
							inspections: f2[1].sort((a, b) => (a.type.name.localeCompare(b.type.name) || a.name.localeCompare(b.name)))
						};
					})
					.sort((a, b) => a.projectName.localeCompare(b.projectName))
			};
		});
		return byCustomerAndProject.sort((a, b) => a.customerName.localeCompare(b.customerName));
	}

	groupBy(collection, keySelector) {
		return collection.reduce(function (rv, x) {
			(rv[keySelector(x)] = rv[keySelector(x)] || []).push(x);
			return rv;
		}, {});
	}
}

window.customElements.define("inspx-local-inspections", InspxLocalInspections);
